export default __webpack_public_path__ + "static/media/fivespices.6606863f.jpeg";